module.exports = __webpack_public_path__ + "static/img/technology-1.ae9be0ea.png";